import React from 'react'
import GiftStore from '../assets/gift-stroke.png'
import { useNavigate } from 'react-router-dom'
import FlecheRetour from '../assets/arrow-back-navigation.svg'

interface TypeOption {
  image: string
  nbrPoint: number
  color: string
  type: string
  description: string
  redirection:string
}
interface TypeGiftCount{
  count:number
  points:number
  type:string
}

interface Props{
  liste:TypeOption[]
  giftCount: TypeGiftCount[]
  handleSelected: () => void
  setIsOpenRecompense: (val:boolean)=>void

}
const Recompense: React.FC<Props> = ({liste, giftCount, handleSelected, setIsOpenRecompense}) => {

  const navigate = useNavigate()
  return (
    <div className='px-[80px] relative lg:px-[20px] flex flex-col items-center gap-6 lg:gap-4 lg:mt-[30px] mt-[50px]'>
      
        <button
              type="button"
              onClick={() =>setIsOpenRecompense(false)}
              className=" cursor-pointer absolute left-0 lg:left-[40px] top-[20px]"
              aria-label="Retour à la page précédente"
            >
              <img src={FlecheRetour} alt="" />
            </button>
      <img src={GiftStore} alt=''/>
      <h2 className="text-[#5754E5] font-bold text-[22px] text-center lg:text-[20px] w-full ">Mes récompenses </h2>
      <p className="text-[#6B7280] text-center text-[16px]">
        {giftCount.length===0 ?
        <span>Aucun cadeau n’est disponible dans <br/> la boutique pour le moment.</span>
        :<span>Retrouvez ici toutes les récompenses <br/>que vous avez déjà obtenues.</span>
        }
        
      </p>
      <div className=" space-y-6  max-h-[500px] overflow-y-auto scrollbar-webkit py-4">
          
        {liste.map((item, index) => (
          <div  key={index}>
            {giftCount.find((gift) => gift.type === item.type)?.count &&
          
              <div
                onClick={() => {
                  // handleSelected()
                  const xx=giftCount.find((gift) => gift.type === item.type)?.count
                   if (
                giftCount.find((gift) => gift.type === item.type)?.count
              ) {
                navigate(item.redirection)
              }
                  }}
                className={` cursor-pointer flex  items-center rounded-[8px] overflow-hidden  shadow-[0px_4px_15px_rgba(0,0,0,0.1)] pr-3`}
              >
                <div className="relative">
                  <div className={`${item.color} absolute  w-[6px] h-full`} />
                  <img src={item.image} width={134} height={134} alt="reward card" />
                
                </div>
                <div className=" w-full flex flex-col gap-3 ">
                  <p className=" text-[#666666] text-[15px] max-w-[280px] font-semibold">Utilisez {item.description}</p>
                  <div className='items-end text-[#666666] text-[12px] flex justify-end'>Qté: <span className='font-bold pl-1'> {giftCount.find((gift)=>gift.type===item.type)?.count}</span></div>
                </div>
              </div>
}
              </div>
            ))}
      </div>

      </div>
  )
}

export default Recompense
